import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlService } from 'src/app/shared/services/url.service';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { AlertService } from 'src/app/shared/services/alert.service';
import { Router } from '@angular/router';
import { VariablesZonaCompartida } from 'src/app/shared/services/VariablesZonaCompartida';

@Component({
    selector: 'app-plan-compensatorio',
    templateUrl: './plan-compensatorio.component.html',
    styleUrls: ['./plan-compensatorio.component.scss']
})

export class PlanCompensatorioComponent implements OnInit {

    public consultaCompensaciones: any[];
    public nombreCompensacion: string;
    public fechaInicialComp: Date;
    public fechaFinalComp: Date;
    public estado: string;
    public filtroNombre: string;
    public p: any;

    constructor(
        private router: Router,
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService
    ) {
        this.consultaCompensaciones = [];
    }

    ngOnInit() {
        this.consultarPlanesDeCompensacion();
    }

    consultarPlanesDeCompensacion() {
        this.spinner.show();
        const serviceProvider = 'consultarPlanesDeCompensacion';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filtroNombre', this.filtroNombre]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
         this.urlService.hostAPI_FUNCIONARIOS);
        this.global.postGenerico(url).subscribe(
            data => {
                    this.consultaCompensaciones = data;
                    this.spinner.hide();
            }, err => {
                if (err.status === 500) {
                    this.cathException(err.error.message);
                    this.consultaCompensaciones.length = 0;
                } else {
                    this.cathException('No es posible consultar las compensaciones');
                }
            }
        );
    }

    /**
     * Metodo que realiza el llamado al componente guardar-compensaciones para crear compensacion
     */
    crearCompensacion() {
        if (!this.consultaCompensaciones.find(plan => plan.estado == 'Activo')) {
            this.global.zonaCompartida[VariablesZonaCompartida.DATOS_COMPENSACION] = undefined;
            this.router.navigate(['/main/plan-compensatorio/guardar-compensacion']);
        } else {
            this.cathException('Ya existe un plan de compensación activo');
        }
    }

    /**
     * Metodo que realiza el llamado al componente guardar-compensaciones para editar informacion
     */
    editarRegistro(event) {
        const registrocompensatorio = {
            id: event.idPlanCompensacion,
            nombre: event.nombrePlanCompensacion,
            fInicial: event.fechaInicial,
            fFinal: event.fechaFinal,
            estado: event.estado
        };
        this.global.zonaCompartida[VariablesZonaCompartida.DATOS_COMPENSACION] = registrocompensatorio;
        this.router.navigate(['/main/plan-compensatorio/guardar-compensacion']);
    }

    /**
     * Método de control de Excepciones
     * @param error mensaje saliente respecto al error ocurrido
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }
}
